import { useEffect, useRef } from 'react';

import { useAuth } from '@/lib/auth';
import { clearAllPropertySelectionStorage } from '@/lib/property-select/property-selection-storage';

/**
 * Clears persisted per-scope property selections when the session ends so the next user
 * does not inherit another tenant's stored ids.
 */
export function useClearPropertySelectionOnLogout(): void {
  const { user } = useAuth();
  const hadUserIdRef = useRef<string | undefined>(undefined);

  useEffect(() => {
    const id = user?.id;
    if (hadUserIdRef.current && !id) {
      clearAllPropertySelectionStorage();
    }
    if (id) {
      hadUserIdRef.current = id;
    }
  }, [user?.id]);
}
